import { createContext, useContext } from 'react'

import { GET_STARTED_ENTRY_ROUTE } from '~/get-started/entryRoute.const'

/** Where this page's sign-up CTAs go, so a partner page need not thread it through every section. */
export const LandingEntryRouteContext = createContext<string>(GET_STARTED_ENTRY_ROUTE)

export const useLandingEntryRoute = (): string => useContext(LandingEntryRouteContext)
